"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SourceMediaBody = _interopRequireDefault(require("./SourceMediaBody"));
var _DisconnectedBody = _interopRequireDefault(require("./DisconnectedBody"));
var _SourceListCameraPresenterItemBody = require("./SourceListCameraPresenterItemBody.styled");
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var SourceListCameraPresenterItemBody = function SourceListCameraPresenterItemBody(_ref) {
  var value = _ref.value,
    type = _ref.type,
    hidden = _ref.hidden,
    live = _ref.live,
    disconnected = _ref.disconnected,
    isCameraOn = _ref.isCameraOn,
    onThumbnailReady = _ref.onThumbnailReady,
    isInitializing = _ref.isInitializing,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    title = _ref.title,
    photo = _ref.photo;
  if (disconnected && value !== _broadcastSourceHelper.UNASSIGNED) return _react["default"].createElement(_DisconnectedBody["default"], null);
  return _react["default"].createElement(_SourceListCameraPresenterItemBody.Wrapper, null, _react["default"].createElement(_SourceMediaBody["default"], {
    value: value,
    type: type,
    hidden: hidden,
    live: live,
    isCameraOn: isCameraOn,
    onThumbnailReady: onThumbnailReady,
    isInitializing: isInitializing,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    title: title,
    photo: photo
  }));
};
SourceListCameraPresenterItemBody.propTypes = {
  value: _propTypes["default"].string,
  type: _propTypes["default"].string,
  hidden: _propTypes["default"].bool,
  live: _propTypes["default"].bool,
  disconnected: _propTypes["default"].bool,
  isCameraOn: _propTypes["default"].bool,
  onThumbnailReady: _propTypes["default"].func,
  isInitializing: _propTypes["default"].bool,
  attendeeTiles: _propTypes["default"].object,
  meetingSession: _propTypes["default"].object,
  title: _propTypes["default"].string,
  photo: _propTypes["default"].string
};
var _default = exports["default"] = SourceListCameraPresenterItemBody;